<template>
    <div>
        <br>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0" v-on:keypress.enter.prevent="searchCheque">
                    <input class="form-control col-1" v-model="search.amount" placeholder="ยอดเงิน"/>&nbsp;
                    <input class="form-control col-1" v-model="search.ref_no" placeholder="หมายเลขเช็ค"/>&nbsp;
                    <date-picker
                        v-model="search.date"
                        type="date"
                        :format="changeFormat"
                        :lang="lang"
                        range
                        confirm
                        placeholder="วันที่นำเข้าเช็ค P">
                    </date-picker>&nbsp;
                    <multiselect
                        class="form-control select"
                        v-model="search.vendor"
                        :options="optionVendor"
                        :customLabel="vendorLabel"
                        placeholder="เลือกรหัสเจ้าหนี้"
                        :show-labels="false"
                        track-by="id"
                        style="border-style: none">
                    </multiselect>&nbsp;
                    <multiselect
                        class="form-control select"
                        v-model="search.cheque_bank_id"
                        :options="optionBank"
                        :customLabel="customLabelBank"
                        :show-labels="false"
                        placeholder="เลขบัญชีธนาคาร"
                        track-by="id"
                        style="border-style: none;width: 300px">
                    </multiselect>&nbsp;
                    <b-form-select v-model="search.status" :options="optionStatus">
                    </b-form-select>&nbsp;
                    <button type="button" class="btn btn-success" @click="searchCheque">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>&nbsp;
                    <button type="button" class="btn btn-secondary" @click="printExcel">
                        <icon name="print"></icon>
                        รายงานเช็ค
                    </button>
                </form>
            </div>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered" style="text-align: center">
                <thead>
                <tr>
                    <th scope="col">วันที่เช็ค</th>
                    <th scope="col">ประเภทการตัดจ่าย</th>
                    <th scope="col">เจ้าหนี้</th>
                    <th scope="col">ธนาคาร</th>
                    <th scope="col">เลขที่เช็ค</th>
                    <th scope="col">ยอดเงิน</th>
                    <th scope="col">วันที่นำเข้าเช็ค P</th>
                    <th scope="col">สถานะ</th>
                    <th scope="col" v-if="canViewSuperAdmin">แก้ไขข้อมูล</th>
                    <th scope="col" v-if="canViewSuperAdmin">ลบข้อมูล</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="data in chequeList">
                    <td>
                        <template v-if="data.date">
                            {{ data.date | moment("DD/MM/YYYY") }}
                        </template>
                    </td>
                    <td>{{ data.payment_name }}</td>
                    <td>
                        <template v-if="data.vendor">
                            {{ data.vendor.vendor_id }} {{ data.vendor.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>{{ data.bank_name }}</td>
                    <td>{{ data.ref_no }}</td>
                    <td>{{ data.amount | currency }}</td>
                    <td>
                        <template v-if="data.approve_date">
                            {{ data.approve_date | moment("DD/MM/YYYY") }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <template v-if="data.status==1">
                            <span style="color: #00a699">P</span>
                        </template>
                        <template v-else>
                            <a @click="editChequeStatus(data.id)"
                               style="color: red; text-decoration: underline">รายการรอจ่าย</a>
                        </template>
                    </td>
                    <td v-if="canViewSuperAdmin">
                        <button type="button" class="btn btn-info" @click="editChequeStatus(data.id)">
                            <icon name="pencil-alt"></icon>
                            แก้ไข
                        </button>
                    </td>
                    <td v-if="canViewSuperAdmin">
                        <button type="button" class="btn btn-danger" @click="showDeleteChequeList(data.id)">
                            <icon name="trash"></icon>
                            ลบ
                        </button>
                    </td>
                </tr>
                </tbody>
            </table>
            <div v-if="chequeList.length > 0">
                <vue-pagination :pagination="dataPaginate"
                                @paginate="getPage">
                </vue-pagination>
            </div>
        </div>
        <b-modal hide-header hide-footer
                 ref="edit_chequeList">
            <div>
                <cheque-rr-payoff-modal @submit="saveChequeRRPayoff"/>
            </div>
        </b-modal>
        <b-modal
            ref="delete_item"
            hide-header
            hide-footer>
            <div style="text-align: center;">
                <h4>คุณต้องการลบใช่หรือไม่</h4>
                <br/>
                <button type="button"
                        class="btn btn-success"
                        @click="DeleteCheque()">ตกลง
                </button>
                &nbsp&nbsp
                <button type="button"
                        class="btn btn-secondary"
                        @click="hideDeleteChequeList()">ยกเลิก
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ChequeRrPayoffModal from "./ChequeRRPayoffModal";
import moment from "moment";
import DatePicker from 'vue2-datepicker';
import VuePagination from "../../Pagination";
import {canViewSuperAdmin} from "../../../util/Permissions";
import Multiselect from "vue-multiselect";
import {mapState} from "vuex";
import {domain} from "../../../util/Constants";

export default {
    components: {
        VuePagination,
        ChequeRrPayoffModal, DatePicker, Multiselect
    },
    name: "cheque-r-r-payoff-list",
    data() {
        return {
            chequeList: [],
            delete_id: '',
            page: 1,
            search: {
                date: [],
                amount: '',
                ref_no: '',
                vendor: '',
                status: 2,
                cheque_bank_id: '',
            },
            optionStatus: [
                {value: 2, text: 'เลือกสถานะ'},
                {value: null, text: 'รายการรอจ่าย'},
                {value: 1, text: 'P'},
            ],
            event_search: false,
            dataPaginate: {
                current_page: 1,
                from: 1,
                last_page: 1,
                per_page: 1,
                total: 1,
                to: 1
            },
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    created() {
        this.getChequeRRPayoffPage();
        this.$store.dispatch("Bank/getBankAll");
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            optionVendor: state => {
                return state.Vendor.vendorAll
            },
            optionBank: state => {
                return state.Bank.bank_all;
            },
        })
    },
    methods: {
        customLabelBank(option) {
            return `${option.account_number} - ${option.name}`
        },
        vendorLabel(option) {
            return `${option.vendor_id} - ${option.name}`
        },
        showDeleteChequeList(id) {
            this.delete_id = id;
            this.$refs.delete_item.show();
        },
        hideDeleteChequeList() {
            this.$refs.delete_item.hide();
        },
        DeleteCheque() {
            this.$store.dispatch('RRPayoff/deleteChequeRRPayoff', this.delete_id).then(() => {
                this.hideDeleteChequeList();
                this.getChequeRRPayoffPage();
            });
        },
        getChequeRRPayoffPage() {
            this.$store.dispatch("RRPayoff/getChequeRRPayoff", this.page).then(res => {
                this.chequeList = res.data;
                this.dataPaginate = {
                    current_page: res.current_page,
                    from: res.from,
                    last_page: res.last_page,
                    per_page: res.per_page,
                    total: res.total,
                    to: res.to
                }
            });
        },
        editChequeStatus(id) {
            //console.log(id);
            this.$store.dispatch("RRPayoff/showChequeRRPayoff", id).then(() => {
                this.$refs.edit_chequeList.show();
            });
        },
        saveChequeRRPayoff(value) {
            if (value) {
                this.$store.dispatch("RRPayoff/updateChequeRRPayoff", {
                    id: value.id,
                    data: value
                }).then(() => {
                    this.getChequeRRPayoffPage();
                });
            }
            this.$refs.edit_chequeList.hide();
        },
        searchCheque() {
            let data = {
                page: this.page,
                start_date: this.search.date.length > 0 ? moment(this.search.date[0]).format("YYYY-MM-DD") : '',
                end_date: this.search.date.length > 0 ? moment(this.search.date[1]).format("YYYY-MM-DD") : '',
                amount: this.search.amount,
                ref_no: this.search.ref_no,
                vendor: this.search.vendor ? this.search.vendor.id : '',
                status: this.search.status,
                cheque_bank_id: this.search.cheque_bank_id ? this.search.cheque_bank_id.id : '',
            };
            this.event_search = true;
            this.$store.dispatch("RRPayoff/searchChequeRRPayoff", data).then(res => {
                this.chequeList = res.data;
                this.dataPaginate = {
                    current_page: res.current_page,
                    from: res.from,
                    last_page: res.last_page,
                    per_page: res.per_page,
                    total: res.total,
                    to: res.to
                }
            });
        },
        printExcel() {
            let data = {
                page: this.page,
                start_date: this.search.date.length > 0 ? moment(this.search.date[0]).format("YYYY-MM-DD") : '',
                end_date: this.search.date.length > 0 ? moment(this.search.date[1]).format("YYYY-MM-DD") : '',
                amount: this.search.amount,
                ref_no: this.search.ref_no,
                vendor: this.search.vendor ? this.search.vendor.id : '',
                status: this.search.status,
                cheque_bank_id: this.search.cheque_bank_id ? this.search.cheque_bank_id.id : '',
            };
            window.open(domain +
                "/search_cheque_list_pay?page=" + data.page + "&amount=" + data.amount
                + "&cheque_bank_id=" + data.cheque_bank_id + "&end_date=" + data.end_date + "&ref_no=" + data.ref_no
                + "&start_date=" + data.start_date + "&status=" + data.status + "&vendor=" + data.vendor + "&excel=excel");
        },
        getPage() {
            this.page = this.dataPaginate.current_page;
            if (this.event_search) {
                this.searchCheque();
            } else {
                this.getChequeRRPayoffPage();
            }
        }
    }
}
</script>

<style scoped>

</style>
